import { Component } from '@angular/core';
import { FromulariodespachoComponent } from 'app/components/servicio-medico/despacho/subdespacho/fromulariodespacho/fromulariodespacho.component';
import { Router } from '@angular/router';

@Component({
    selector   : 'footer',
    templateUrl: './footer.component.html',
    styleUrls  : ['./footer.component.scss']
})
export class FooterComponent
{
    public vista;
    /**
     * Constructor
     */
    constructor(private router:Router)
    {
        /* console.log(this.router.isActive('/servicio-medico/despacho',true)) */
        this.vista = this.router.isActive('/servicio-medico/despacho', true);
        this.router.events.subscribe(event=>{
            this.vista = this.router.isActive('/servicio-medico/despacho',true);
            /* console.log(this.vista) */
        })
    }
}
